/* eslint-disable import/prefer-default-export */
export const useWhite = { // 接口请求白名单，以签名为维度区分
  vipWhiteList: ['/user/extra/status'], // 会员状态，使用 dict-vip 签名
  skipWhiteList: ['/collect/docreport'], // 需要跳过签名
}
